<template>
    <LayoutDefault>
        <UContainer class="pt-3 pb-16">
            <Breadcrumb v-if="pageData?.breadcrumb" :items="pageData.breadcrumb" class="mb-4 lg:mb-6" />
            <h1 class="font-poppins text-28 lg:text-4xl font-semibold leading-9 lg:leading-12 text-brand-dark-blue mb-6">
                {{ t('blog.title') }}
            </h1>
            <BlogCategoriesBar v-if="blogCategories?.length" :categories="blogCategories" class="mb-6 lg:mb-8.5" />
            <BlogArticlesGrid
                v-if="parentPageId"
                :parent-page-id="pageData?.type === 'news_all' ? parentPageId : undefined"
                :page-id="pageData?.type === 'news' ? pageData?.id : undefined"
            />
        </UContainer>
    </LayoutDefault>
</template>
<script setup lang="ts">
const { t } = useI18n()
const api = useApi();
const { locale } = useI18n();

const route = useRoute();

const blogRoute = computed(() => {
  let path = route.path;
  if (path.startsWith(`/${locale.value}/`)) {
    path = path.replace(`/${locale.value}/`, '/');
  }
  return path.endsWith('/') ? path : path + '/';
})

const {
  data: blogCategoriesData
} = await useAsyncData(`blog-categories-${locale.value}`, () => api.getBlogCategories(), {
  server: true,
  lazy: false,
  default: () => null,
  transform: res => res.data ?? null,
  watch: [locale]
});

const blogCategories = computed(() => blogCategoriesData.value?.items ?? [])
const parentPageId = computed(() => blogCategoriesData.value?.parent_page_id)

const {
  data: pageData
} = await useAsyncData(() => `blog-${blogRoute.value}-${locale.value}`, () => api.getPageByPath(blogRoute.value), {
  immediate: true,
  server: true,
  lazy: false,
  default: () => null,
  transform: res => res.data,
  watch: [blogRoute,locale]
});

// if (!pageData.value) {
//   throw createError({ statusCode: 404, statusMessage: t('errors.pageNotFound') });
// }

// const isInteractivePage = (page: any) => {
//   return page?.type && ['interactive_page', 'contact_page'].includes(page?.type)
// }

useSeoMeta({
  title: pageData.value?.meta_title,
  description: pageData.value?.meta_description
})

useCmsHreflang(() => pageData.value?.alternate_urls)
</script>